import React, { Fragment, useState } from "react";
import styles from "./Input.module.css";
const Input = (props) => {
  const [typedValue, setTypedValue] = useState("");
  return (
    <Fragment>

    <input
      id={props.id}
      name={props.name}
      key={props.key}
      label={props.label}
      elementType={props.elementType}
      className={styles.input}
      style={{
        width: props.width && props.width,
        textTransform: props.textTransform && props.textTransform,
        fontSize: props.fontSize && props.fontSize,
        ...props.customStyle
      }}
      type="text"
      placeholder={props.placeholder}
      value={props.Value}
      onChange={(event) => props.onChange(event)}
      disabled={props.disabled}
    />
    {<p style={{fontSize:"12px", color:"red", fontStyle:"italic"}}>{props.error_text}</p>}
    </Fragment>
  );
};

export default Input;
